import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-textarea',
  standalone: true,
  templateUrl: './ui-textarea.component.html',
  styleUrl: './ui-textarea.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiTextareaComponent),
      multi: true,
    },
  ],
})
export class UiTextareaComponent implements ControlValueAccessor, AfterViewInit {
  /** Сюда передаётся Example поля. */
  @Input() placeholder = '';
  /** Пример (Example); раскрывается по кнопке. */
  @Input() example = '';
  @Input() rows = 6;
  @Input() minHeight = 196;
  @Input() invalid = false;
  @Input() readonly = false;
  @Input() maxlength: number | null = null;

  @ViewChild('ta') private taRef?: ElementRef<HTMLTextAreaElement>;

  value = '';
  disabled = false;
  showExample = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  ngAfterViewInit(): void {
    this.adjustHeight();
  }

  writeValue(value: string): void {
    this.value = value ?? '';
    // writeValue может прийти до того, как #ta срендерится — отложим до следующего тика.
    setTimeout(() => this.adjustHeight());
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    this.value = (event.target as HTMLTextAreaElement).value;
    this.onChange(this.value);
    this.adjustHeight();
  }

  private adjustHeight(): void {
    const el = this.taRef?.nativeElement;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.max(el.scrollHeight, this.minHeight) + 'px';
  }

  onBlur(): void {
    this.onTouched();
  }

  toggleExample(): void {
    this.showExample = !this.showExample;
  }

  insertExample(): void {
    this.value = this.example;
    this.onChange(this.value);
    this.showExample = false;
  }

  get count(): number {
    return (this.value || '').trim().length;
  }

  get hasExample(): boolean {
    return !!this.example && this.example.trim().length > 0;
  }
}
